import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('pagamento_verbas_estruturais', 'criacao');

const pagamentoActions = {
  criar: { method: 'POST', url: `${basePath}/{idApuracao}` },
};

export default resource => resource(`${basePath}`, {}, pagamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/pagamento-criacao.js